import { createFileRoute } from '@tanstack/react-router';
import { SandboxPage } from '../sandbox-page';
export const Route = createFileRoute('/academy/$lessonId')({ component: LessonRoute });
function LessonRoute() { const { lessonId } = Route.useParams(); return <SandboxPage academy lessonId={lessonId} />; }
